














import { Component, Vue } from "vue-property-decorator";

import TvConfiguration from "@/components/apps-configuration/tv-configuration.vue";
import MobileConfiguration from "@/components/apps-configuration/mobile-configuration.vue";
import SignConfiguration from "@/components/apps-configuration/sign-configuration.vue";
import SettingsConfiguration from "@/components/apps-configuration/settings-configuration.vue";
import { isFiloxeniaAppHidden } from "@/services/featureConfig";

@Component({
  components: {
    TvConfiguration,
    SignConfiguration,
    MobileConfiguration,
    SettingsConfiguration,
  },
})
class FiloxeniaConfiguration extends Vue {
  allApps: Array<string> = (process.env.VUE_APP_FILOXENIA_APPS || "").split(
    ","
  );
  tabIndex = 0;

  get apps(): Array<string> {
    return this.allApps.filter((app) => !isFiloxeniaAppHidden(app));
  }
}
export default FiloxeniaConfiguration;
